import { Component, HostListener, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationService } from 'primeng/api';
import { HelpersService } from 'src/app/services';
import { InvoiceService } from 'src/app/services/invoice.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-workshop-jobcard-manage-collections',
  templateUrl: './workshop-jobcard-manage-collections.component.html',
  styleUrls: ['./workshop-jobcard-manage-collections.component.scss']
})
export class WorkshopJobcardManageCollectionsComponent {

  @Input() collections: any[] = [];

  public showCreateCollectionButton: boolean = false;
  public collectionName: string = '';

  constructor(
    public activeModal: NgbActiveModal,
    private invoiceService: InvoiceService,
    private helpersService: HelpersService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService
  ) {

  }

  createCollection(closeModal: boolean = false) {
    if (this.collectionName.trim() !== '') {
      const data = {
        collectionName: this.collectionName,
        partnerID: this.helpersService.getPartnerId()
      };
      this.invoiceService.addProductCollection(data).subscribe((response) => {
        this.collections.push(response.productCollection);
        this.collectionName = '';
        this.showCreateCollectionButton = false;
        if (closeModal) {
          this.activeModal.close({});
        }
      }, err => {
        console.error('Error creating collection:', err);
      });
    }
  }

  deleteCollection(collection: any) {
    this.confirmationService.confirm({
      message: this.translate.instant('bikeshop.workshop.jobcard.quote.collection.delete_collection_message', {collectionName : collection.collectionName}),
      header: this.translate.instant('bikeshop.workshop.jobcard.quote.collection.delete_collection_header'),
      key: 'delete-collection-dialog',
      acceptLabel: this.translate.instant('general.yes'),
      rejectLabel: this.translate.instant('general.no'),
      accept: () => {
        var data = { ...collection, isActive: false }
        this.invoiceService.addProductCollection(data).subscribe(() => {
          this.collections = this.collections.filter(c => c.id !== collection.id);
        }, err => {
          console.error('Error deleting collection:', err);
        });
      }
    });
  }

  @HostListener('document:keydown.enter', ['$event'])
  handleEnter(event: KeyboardEvent) {
    this.createCollection(true);
  }
}
